
<template>
  <div>
    <!-- Dialog para ver resumo -->
    <v-dialog persistent max-width="700px" class="ma-0" v-model="resume_dialog">
      <v-card>
        <v-card-title class="red white--text">
          <div class="d-flex align-center">
            <v-icon class="white--text" left>mdi-note-multiple</v-icon>
            Resumo do pedido
          </div>
        </v-card-title>
        <v-card-text style="overflow-y: auto; max-height: 75vh">
          <OrderResume :solution="order.solution" :order="selected_order"></OrderResume>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <f-btn cancel @click="resume_dialog = false"></f-btn>
          <v-btn @click="redoOrder" small color="primary">
            <v-icon small class="white--text" left>mdi-content-copy</v-icon>
            Refazer pedido
          </v-btn>          
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Card de resumo dos pedidos -->
    <v-card elevation="9" outlined>
      <v-card-title class="red white--text">
        <div class="d-flex align-center">
          <v-icon class="white--text" left>mdi-history</v-icon>
          Últimos pedidos do cliente
        </div>
      </v-card-title>
      <v-card-text class="pa-0">
        <v-data-table :items="last_orders" :headers="headers" :loading="loading">
          <template v-slot:item.actions="{item}">
            <div class="d-flex align-center">
              <v-tooltip top color="black">
                <template v-slot:activator="{ on }">
                  <v-btn @click="showOrderReviewDialog(item)" v-on="on" small icon class="primary mx-1">
                    <v-icon small class="white--text">mdi-eye</v-icon>
                  </v-btn>
                </template>
                Ver pedido.
              </v-tooltip>
            </div>
          </template>
          <template v-slot:item.order_status="{item}">
            <v-chip small :color="status_map[item.order_status]?.color">
              {{ status_map[item.order_status]?.text }}
            </v-chip>
          </template>
          <template v-slot:item.total_order_bags="{item}">
            <span v-if="item.total_order_bags">
              {{ item.total_order_bags }}
            </span>
            <span v-if="item.total_order_units">
              {{ item.total_order_units }}
            </span>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

  </div>
</template>

<script>
import Api from '@/api/index'
import {mapRetailOrder} from '../retail_components/shared/MapLastRetailOrder';

export default {
  name:'ClientLastOrders',
  props: {
    order: {
      type: Object
    }
  },
  components:{
    OrderResume: () => import("@/components/create_order/shared/OrderResume.vue"),
  },
  data() {
    return {
      loading: false,
      resume_dialog: false,
      selected_order: {
        shipping: {},
        truck: {},
        brand: {},
        driver: {},
        pickup_location: {},
        client_shipping_location_attributes: {},
        delivery_attributes: {},
        items_attributes: [],
      },
      last_orders: [],
      status_map: {
        'to_approve': { text: "Para Aprovar", color:'primary' },
        'to_schedule': { text: "Para Marcar", color:'primary' },
        'to_load': { text: "A Carregar", color:'primary' },
        'to_deliver': { text: "Para entregar", color:'primary' },
        'declined': { text: "Cancelado", color:'error' },
        'problem': { text: "Problema", color:'error' },
        'to_pickup': { text: "Para Retirar", color:'primary' },
        'to_be_paid': { text: "Entregue", color:'success' },
        'pickup_done': { text: "Retirado", color:'success' },
      },
      headers: [
        {text: "Pedido n°", value: 'id' },
        {text: "Qtd. Sacos", value: 'total_order_bags' },
        {text: "Frete", value: 'freight_label' },
        {text: "Motorista", value: 'driver_label' },
        {text: "Placa", value: 'truck_label' },
        {text: "Carregamento", value: 'loading_label' },
        {text: "Status", value: 'order_status' },
        {text: "Ações", value: 'actions' },
      ]
    }
  },
  methods: {
    redoOrder(){
      let {modality_id, driver, truck, client_shipping_location, delivery_attributes, shipping_attributes, ...rest} = this.selected_order

      let order = {}
      order = {
        ...rest,
        driver,
        truck,
        delivery_attributes: { ...delivery_attributes },
        shipping: {
          building: {
            id: client_shipping_location?.building_id.toString()
          }
        },
        shipping_attributes: {
          ...shipping_attributes,
          building_id: null
        }
      }
      if(this.order.client?.client_credit?.status_id == 10 || this.order.client?.credits?.data?.attributes?.status_id == 10){
        order.payments.list = order.payments.list.map(el => {
          return {
            ...el,
            payment_time_id: null,
            payed: false,
            payed_at: null,
          }
        })
      }else{
        order.payments.list = order.payments.list.map(el => {
          return {
            ...el,
            payed: false,
            payed_at: null,
          }
        })
      }
      this.$emit('redo', order)
      this.resume_dialog = false
      this.addNotification({type: 'success', msg: 'Pedido clonado com sucesso!'})
    },
    getData(){
      if(this.order?.solution == 'wholesale'){
        this.getWholesaleOrders()
      }else if(this.order?.solution == 'retail'){
        this.getRetailOrders()
      }
    },
    formatNumber(numero, casas_decimais) {
      var formatedNumber = (parseFloat(numero).toFixed(casas_decimais));
      return formatedNumber;
    },
    showOrderReviewDialog(item){
      this.selected_order = {...this.selected_order, ...item}
      if(this.order?.solution == 'wholesale'){
        this.prepareWholesaleOrder(item)
      }else if(this.order?.solution == 'retail'){
        this.selected_order = mapRetailOrder(item)
      }
      this.resume_dialog = true
    },
    prepareDefaultOrder(item){
      this.selected_order.id = null
      this.selected_order.list = null
      this.selected_order.client_name = item?.client?.name
      this.selected_order.created_by_name = null
      this.selected_order.created_by_id = null
      for(let x in this.selected_order.payments.list){
        delete this.selected_order.payments.list[x].payment_option 
        delete this.selected_order.payments.list[x].payment_time
      }
    },
    formatEstimatedLoading(estimatedLoading) {
      if (!estimatedLoading) return null
      const raw = String(estimatedLoading).substring(0, 10)
      if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) {
        return this.$moment(raw, 'YYYY-MM-DD').format('DD/MM/YYYY')
      }
      if (/^\d{2}\/\d{2}\/\d{4}/.test(String(estimatedLoading))) {
        return String(estimatedLoading).substring(0, 10)
      }
      return this.$moment(estimatedLoading).format('DD/MM/YYYY')
    },
    mapDeliverySource(item) {
      return item?.delivery_data || item?.delivery || {}
    },
    mapDriverFromDelivery(deliverySource, item) {
      const driver = deliverySource?.driver || item?.delivery?.driver
      if (driver?.id || driver?.attributes?.id) return { ...driver }
      if (deliverySource?.driver_id) {
        return {
          id: deliverySource.driver_id,
          name: deliverySource.driver_name || null,
        }
      }
      return null
    },
    mapTruckFromDelivery(deliverySource, item) {
      const truck = deliverySource?.truck || item?.delivery?.truck
      if (truck?.id || truck?.attributes?.id) return { ...truck }
      if (deliverySource?.truck_id || deliverySource?.truck_plate) {
        return {
          id: deliverySource.truck_id || null,
          plate: deliverySource.truck_plate_display || deliverySource.truck_plate || null,
        }
      }
      return null
    },
    mapDeliveryAttributes(deliverySource, driver, truck) {
      const estimatedLoading = deliverySource?.estimatedLoading || deliverySource?.estimated_loading
      return {
        id: null,
        internal: !!deliverySource?.internal,
        driver_id: deliverySource?.driver_id || driver?.id || driver?.attributes?.id || null,
        truck_id: deliverySource?.truck_id || truck?.id || truck?.attributes?.id || null,
        truck_plate: deliverySource?.truck_plate || truck?.plate || truck?.attributes?.plate || null,
        quantity_of_pallets: deliverySource?.quantity_of_pallets ?? 0,
        driver_commission: deliverySource?.driver_commission ?? null,
        needs_pallets: deliverySource?.needs_pallets ?? null,
        freight_kind: deliverySource?.freight_kind ?? null,
        payment_method: deliverySource?.payment_method ?? null,
        estimatedLoading: this.formatEstimatedLoading(estimatedLoading),
      }
    },
    enrichLastOrderLabels(orders) {
      return (orders || []).map(order => {
        const deliverySource = this.mapDeliverySource(order)
        const driver = this.mapDriverFromDelivery(deliverySource, order)
        const truck = this.mapTruckFromDelivery(deliverySource, order)
        const estimatedLoading = deliverySource?.estimatedLoading || deliverySource?.estimated_loading
        return {
          ...order,
          freight_label: deliverySource?.internal ? 'Interno' : (deliverySource?.driver_id || deliverySource?.id ? 'Externo' : '—'),
          driver_label: driver?.name || driver?.attributes?.name || '—',
          truck_label: truck?.plate || truck?.attributes?.plate || deliverySource?.truck_plate || '—',
          loading_label: this.formatEstimatedLoading(estimatedLoading) || '—',
        }
      })
    },
    prepareWholesaleOrder(item){
      this.prepareDefaultOrder(item)
      this.selected_order.without_client = false
      this.selected_order.solution =  'wholesale'
      this.selected_order.client_shipping_location_attributes = {...item?.client_shipping_location}
      this.selected_order.shipping.address_id = item?.client_shipping_location?.address_id
      this.selected_order.brand = {...item?.brand}

      const deliverySource = this.mapDeliverySource(item)
      const driver = this.mapDriverFromDelivery(deliverySource, item)
      const truck = this.mapTruckFromDelivery(deliverySource, item)
      this.selected_order.driver = driver
      this.selected_order.truck = truck
      this.selected_order.delivery_attributes = this.mapDeliveryAttributes(deliverySource, driver, truck)

      this.selected_order.pickup_location = {...item.items?.[0]?.pickup_location}
      this.selected_order.delivery_id = null
      this.selected_order.client_shipping_location_attributes.id = null
      this.selected_order.client_shipping_location_id = null
      this.selected_order.bag_shipping_price = this.formatNumber(item.bag_shipping_price, 4)
      this.selected_order.items_attributes = [...item?.items.map( item => {
        return {
          // ...item,
          // order_id: null,
          // id: null,
          bag_sell_price: this.formatNumber(item.bag_sell_price, 2),
          unit_shipping_price: this.formatNumber(item.unit_shipping_price || 0, 2),
          product: item.product,
          pickup_location_id: item.pickup_location_id,
          product_id: item.product_id,
          product_pickup_location_id: item.product_pickup_location_id,
          total_bags: item.total_bags,
          total_items_sell: item.total_items_sell,
        }
      })]
      
      
      for(let x in this.selected_order.items_attributes){
        let productPickupLocationId = this.selected_order.items_attributes[x].product_pickup_location_id
        this.selected_order.items_attributes[x].product.product_pickup_location_id = productPickupLocationId
        this.selected_order.items_attributes[x].product_pickup_locations_id = productPickupLocationId
        this.selected_order.items_attributes[x].product.product_pickup_locations_id = productPickupLocationId
      }

      this.selected_order.total_order_profit = 0
      this.selected_order.total_order_buy = 0
      this.selected_order.total_order_price = null
      this.selected_order.bag_profit = null

      this.selected_order.payments = {
        list: this.selected_order.payments.list
      }
      
    },
    getWholesaleOrders(){
      this.loading = true
      Api.Order.lastWholesaleOrders({client_id: this.order.client_id, modality_id: this.order.modality_id}).then( res => res.data ).then( res => {
        this.last_orders = this.enrichLastOrderLabels(res)
      }).finally(()=>{
        this.loading = false
      })
    },
    getRetailOrders(){
      this.loading = true
      Api.Order.lastRetailOrders({client_id: this.order.client_id, modality_id: this.order.modality_id}).then( res => res.data ).then( res => {
        this.last_orders = [...res]
      }).finally(()=>{
        this.loading = false
      })
    },
  },
  mounted () {
    this.getData()
  },
  watch: {
    'order.client_id'(nv) {
      this.getData()
    },
    'order.solution'(nv) {
      this.getData()
    },
  },
}
</script>